import * as React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";


import { I18n } from "./I18n";

class ResultProps {
    messageToShow: string;
    onDismiss: () => void;
}


export function ResultOk(props: ResultProps): JSX.Element {
    if (props.messageToShow == null || props.messageToShow == "") {
        return null;
    }
    return (

        <Modal isOpen={true} toggle={() => props.onDismiss()}>
            <ModalHeader
                close={<button className="btn-close" onClick={() => props.onDismiss()} />}
            >
                </ModalHeader>
            <ModalBody>
                <div dangerouslySetInnerHTML={{ __html: props.messageToShow }}></div>
            </ModalBody>
            <ModalFooter>
                <Button onClick={() => props.onDismiss()} >
                    { I18n.Strings.ok }
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export function ResultError(props: ResultProps): JSX.Element {

    if (props.messageToShow == null || props.messageToShow == "") {
        return null;
    }
    return (
        <Modal isOpen={true} toggle={() => props.onDismiss()}>
            <ModalHeader

                close={<button className="btn-close" onClick={() => props.onDismiss()} />}
            >
            </ModalHeader>
            <ModalBody>
                {props.messageToShow}
            </ModalBody>
            <ModalFooter>
                <Button onClick={() => props.onDismiss()} >
                    {I18n.Strings.ok}
                </Button>
            </ModalFooter>
        </Modal>

    );
}

export function ShowMessage(props: ResultProps): JSX.Element {

    if (props.messageToShow == null || props.messageToShow == "") {
        return null;
    }

    return (
        <Modal isOpen={true} toggle={() => props.onDismiss()}>
            <ModalHeader
                close={<button className="btn-close" onClick={() => props.onDismiss()} />}
            >
            </ModalHeader>
            <ModalBody>
                <div
                    dangerouslySetInnerHTML={{ __html: props.messageToShow }}
                />
            </ModalBody>
            <ModalFooter>
                <Button onClick={() => props.onDismiss()} >
                    {I18n.Strings.ok}
                </Button>
            </ModalFooter>
        </Modal >
    );
}
